import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';
import { ITimeline } from 'common/interfaces/timeline.interface';
export interface ITimelineState {
  state: QueryState;
  timeline: ITimeline[];
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const TimelineEmptyState: ITimelineState = {
  state: QueryState.UNDEFINED,
  timeline: [],
  error: null,
  accessToken: undefined
};
